import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { CalendarDays, Clock, TreePalm, User } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import TodayTab from './TodayTab';
import WeekTab from './WeekTab';
import EmployeeTab from './EmployeeTab';
import LeaveTab from './LeaveTab';
import styles from './TimeAttendance.module.css';

// One screen for attendance: Today, Week, Employee and Leave. The tab is in
// the URL (?tab=week) so it survives a reload and can be linked to.
const TABS = [
  { key: 'today', label: 'Today', icon: Clock, Component: TodayTab },
  { key: 'week', label: 'Week', icon: CalendarDays, Component: WeekTab },
  { key: 'employee', label: 'Employee', icon: User, Component: EmployeeTab },
  { key: 'leave', label: 'Leave', icon: TreePalm, Component: LeaveTab },
];

const TimeAttendance = () => {
  const { t } = useLanguage();
  const [params, setParams] = useSearchParams();
  const active = TABS.find((tab) => tab.key === params.get('tab')) || TABS[0];

  return (
    <div className={styles.page}>
      <header className="page-head">
        <h1 className="page-title">{t('Time & Attendance')}</h1>
      </header>

      <nav className="tabbar" role="tablist" aria-label={t('Time & Attendance')}>
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            role="tab"
            id={`ta-tab-${tab.key}`}
            aria-selected={tab.key === active.key}
            aria-controls={`ta-panel-${tab.key}`}
            className={`tabbar__tab${tab.key === active.key ? ' is-active' : ''}`}
            onClick={() => setParams(tab.key === 'today' ? {} : { tab: tab.key })}
          >
            <tab.icon aria-hidden="true" /> {t(tab.label)}
          </button>
        ))}
      </nav>

      <section
        className={styles.panel}
        role="tabpanel"
        id={`ta-panel-${active.key}`}
        aria-labelledby={`ta-tab-${active.key}`}
      >
        <active.Component />
      </section>
    </div>
  );
};

export default TimeAttendance;
